// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"Tq-z","title":"Uq-z","nav":"Vq-z","flexCell":"Wq-z","facetLink":"Xq-z"};